export const nextSingleDigitNonZero = (num: number) => {
  // Find the number of digits in `num`
  const numDigits = Math.max(Math.floor(Math.log10(num)) + 1, 1);

  // Get the first digit and increment it
  const firstDigit = Math.floor(num / Math.pow(10, numDigits - 1)) + 1;

  // Construct the next single non-zero digit number by scaling the first digit
  return Math.max(firstDigit * Math.pow(10, numDigits - 1), 10);
};

export interface calculateBarChartValuesInput {
  bars: {
    label: string;
    stacks: Array<{ stackLabel: string; value: number }>;
  }[];
  showTotals?: boolean;
  relativeValues?: boolean;
}

const calculateBarChartValues = ({
  bars,
  showTotals,
  relativeValues,
}: calculateBarChartValuesInput) => {
  const totalsByStack = showTotals
    ? bars.reduce<Record<string, number>>((acc, bar) => {
        bar.stacks.forEach((stack) => {
          acc[stack.stackLabel] = (acc[stack.stackLabel] || 0) + stack.value;
        });
        return acc;
      }, {})
    : undefined;

  const totalValues = bars.map((bar) =>
    bar.stacks.reduce(
      (previousValue, currentValue) => previousValue + currentValue.value,
      0,
    ),
  );
  const totalValue = totalValues.reduce((acc, num) => acc + num, 0);
  const calculatedMaxValue = Math.min(
    nextSingleDigitNonZero(
      showTotals ? totalValue : Math.max(...totalValues, 0),
    ),
    relativeValues ? 100 : Infinity,
  );
  return { totalValue, calculatedMaxValue, totalsByStack };
};

export default calculateBarChartValues;
